<template>
  <div class="help-center-mobile-menu-tree__component">
    <HelpCenterMobileMenuGroup
      v-for="menuGroup in menu"
      :key="menuGroup.id"
      :menu-group="menuGroup"
      :selected-tab="selectedTab"
      class="help-center-mobile-menu-tree__group"
      @navigate="onNavigate"
    />
  </div>
</template>

<script setup>
import HelpCenterMobileMenuGroup from 'help-center/components/HelpCenterMobileMenuGroup'

const emit = defineEmits(['navigate'])

defineProps({
  menu: {
    type: Array,
    required: true
  },
  selectedTab: {
    type: Object,
    required: true
  }
})

function onNavigate() {
  emit('navigate')
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-mobile-menu-tree {
  &__component {
    display: flex;
    flex-direction: column;

    padding: $helpCenterMobileVerPadding $helpCenterMobileHorPadding;
    border-bottom: 1px solid var(--help-center-border);
    background-color: white;
  }

  &__group {
    & + & {
      margin-top: $helpCenterMobileVerPadding;
      border-top: 1px solid var(--help-center-border);
      padding-top: $helpCenterMobileVerPadding;
    }
  }
}
</style>
